
















































































































































































































































































import axios from 'axios';
import i18n from 'vue-i18n';
import { sub, isAfter } from 'date-fns';
import EventBus from '@/eventBus';
import { google, outlook, office365, yahoo, ics } from 'calendar-link';
import { get } from 'lodash';
import CoRoundButton from '@/components/Atoms/co-round-button/CoRoundButton.vue';
import CoText from '@/components/Atoms/co-text/CoText.vue';
import CoIcon from '@/components/Atoms/co-icon/CoIcon.vue';
import CoHeadline from '@/components/Atoms/co-headline/CoHeadline.vue';
import CoCard from '@/components/Molecules/co-card/CoCard.vue';
import CoButton from '@/components/Atoms/co-button/CoButton.vue';
import CoDropdown from '@/components/Molecules/co-dropdown/CoDropdown.vue';
import CoTable from '@/components/Molecules/co-table/CoTable.vue';
import CoLoadingIndicator from '@/components/Atoms/co-loading-indicator/coLoadingIndicator.vue';
import CoBookingModal from '@/components/Organisms/co-booking-modal/CoBookingModal.vue';

export default {
    components: { CoRoundButton, CoText, CoIcon, CoHeadline, CoCard, CoButton, CoTable, CoBookingModal },
    name: 'CoMyBookings',
    data() {
        return {
            loading: true,
            bookings: [],
            bookingshistory: [],
            next: null,

            googleCalendarLink: '',
            icsCalendarLink: '',
            outlookCalendarLink: '',

            bookingForView: null,

            bookingsBeingCancelled: {},
        };
    },
    computed: {
        userTimeZone() {
            try {
                return Intl.DateTimeFormat().resolvedOptions().timeZone;
            } catch (e) {
                return null;
            }
        },
    },
    created() {
        this.getMyBookingsHistory();
    },
    methods: {
        get,
        clickedRow(index, item) {
            this.handleEventClick(item);
        },
        sortBookings(input) {
            input.forEach((element) => {
                const start = new Date(get(element, 'Start', 0) * 1000);
                const now = new Date();

                const cancelPeriod = start;
                const diff = sub(cancelPeriod, {
                    hours: get(element, 'Resource.CancellationPeriod', 0),
                });
                let canCancel = true;
                if (isAfter(now, diff) || element?.Status === 'cancelled') {
                    canCancel = false;
                }
                element.canCancel = canCancel;

                if (isAfter(start, now) && element?.Status !== 'cancelled') {
                    this.bookings.push(element);
                } else {
                    this.bookingshistory.push(element);
                }
            });
        },
        getMyBookingsHistory() {
            let url = '/booking/my';
            if (this.next) {
                url = this.next;
            }
            axios({
                method: 'GET',
                url,
                withCredentials: true,
                headers: {
                    'Content-Type': 'application/json',
                },
            })
                .then((response) => {
                    this.next = get(response, 'data.Next', null);
                    const bookings = get(response, 'data.Bookings', []).filter((item) => !item.Block);

                    if (bookings.length === 0) {
                        return;
                    }
                    this.sortBookings(bookings);
                    // load first page of bookings history if not already loaded on first load
                    if (this.bookingshistory.length === 0 && this.next?.length > 0) {
                        this.getMyBookingsHistory();
                    }
                })
                .catch((error) => {
                    console.log(error);
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        bookingModalClosed() {
            this.bookingForView = null;
        },
        bookingCancelFailed(error) {
            EventBus.$emit('ERROR', {
                Message: this.$t('errors.failedGeneric'),
                Details: get(error, 'response.data', ''),
            });
        },
        bookingCanceled() {
            this.bookings = this.bookings.filter((item) => item?.ID !== this.bookingForView?.ID);
            this.bookingForView = null;
            EventBus.$emit('INFO', {
                Message: this.$t('messages.booking.cancelSuccess'),
            });
        },
        handleEventClick(bkng) {
            this.bookingForView = bkng;
        },

        cancelBooking(booking) {
            this.bookingsBeingCancelled[booking.ID] = true;
            this.$store
                .dispatch('cancelBookingV2', booking.ID)
                .then((response) => {
                    this.bookingCanceled();
                    this.bookings = this.bookings.filter((item) => item.ID !== booking.ID);
                })
                .catch((error) => {
                    this.bookingCancelFailed(error);
                })
                .finally(() => {
                    this.bookingsBeingCancelled[booking.ID] = false;
                });
        },

        convertToPlain(html) {
            const tempDivElement = document.createElement('div');
            tempDivElement.innerHTML = html;
            return tempDivElement.textContent || tempDivElement.innerText || '';
        },
        makeCalendarLink(booking, type) {
            this.calendarEvent = {
                title: booking.Title,
                description: this.convertToPlain(booking.Resource.Name),
                start: new Date(booking.Start * 1000).toISOString(),
                end: new Date(booking.End * 1000).toISOString(),
            };

            // Then fetch the link
            if (type === 'google') {
                this.googleCalendarLink = google(this.calendarEvent);
                window.location.href = this.googleCalendarLink;
            } else if (type === 'outlook') {
                this.outlookCalendarLink = outlook(this.calendarEvent);
                window.location.href = this.outlookCalendarLink;
            } else if (type === 'ics') {
                this.icsCalendarLink = ics(this.calendarEvent);
                window.location.href = this.icsCalendarLink;
            }
        },
    },
};
